import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { environment } from './environments/environment';
import * as Sentry from '@sentry/angular';

if (environment.sentry_enabled) {
  Sentry.init({
    dsn: environment.sentry_dsn,
    environment: environment.sentry_environment,
    release: environment.sentry_release,
    sendDefaultPii: true
  });
}

window.addEventListener('error', (event) => {
  if (event.message?.includes('ResizeObserver loop completed')) {
    event.stopImmediatePropagation();
  }
});

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
